import type { ISamplePool } from 'Model/index.js'

export const samplePool1: ISamplePool = {
  id: 'samplePool1',
  orderId: 'order123',
  samples: [
    {
      id: 'sample1',
      version: 'dummy',
      isTrimmed: false,
      isMerged: false,
      primerLiterature: 'Darwin et al, 1872',
      itemType: 'SAMPLE',
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_1.ID',
      reverseFileId: 'reverse_read_1.ID',
      forwardPrimer: 'CGCGGGWACWGGWTGAACWGTWTAYCCYCC',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      reversePrimer: 'CGGTTGTAAACTTCAGGGTGACCAAARAAYCA',
      customerSampleName: 'customerSampleA',
      sampleMetadata: {
        customerSampleName: 'customerSampleA',
        id: 'sampleMetaData1',
        orderId: 'order123',
        version: '1.0',
        isShadowed: false
      }
    },
    {
      id: 'sample2',
      version: 'dummy',
      isTrimmed: false,
      isMerged: false,
      primerLiterature: 'Darwin et al, 1872',
      forwardPrimer: 'TATTGGWACWGGWTGAACWGTWTAYCCYCC',
      itemType: 'SAMPLE',
      reversePrimer: 'GTCCTATAAACTTCAGGGTGACCAAARAAYCA',
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_2.ID',
      reverseFileId: 'reverse_read_2.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      customerSampleName: 'customerSampleB',
      sampleMetadata: {
        customerSampleName: 'customerSampleB',
        id: 'sampleMetaData1',
        orderId: 'order123',
        version: '1.0',
        isShadowed: false
      }
    }
  ],
  negativeControls: [
    {
      id: 'control1',
      version: 'dummy',
      isTrimmed: false,
      isMerged: false,
      itemType: 'NEGATIVE_CONTROL',
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_1.ID',
      reverseFileId: 'reverse_read_1.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      }
    }
  ]
}

export const samplePool2: ISamplePool = {
  id: 'samplePool2',
  orderId: 'order124',
  samples: [
    {
      id: 'sample3',
      version: 'dummy',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_3.ID',
      reverseFileId: 'reverse_read_3.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      }
    }
  ],
  negativeControls: [
    {
      id: 'control2',
      version: 'dummy',
      itemType: 'NEGATIVE_CONTROL',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_2.ID',
      reverseFileId: 'reverse_read_2.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      }
    }
  ]
}

export const samplePool3: ISamplePool = {
  id: 'samplePool3',
  orderId: 'order125',
  samples: [
    {
      id: 'sample4',
      version: 'dummy',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      primerLiterature: 'Darwin et al, 1872',
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_4.ID',
      reverseFileId: 'reverse_read_4.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      customerSampleName: 'customerSampleC'
    }
  ],
  negativeControls: [
    {
      id: 'control3',
      version: 'dummy',
      itemType: 'NEGATIVE_CONTROL',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_3.ID',
      reverseFileId: 'reverse_read_3.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      }
    }
  ]
}

export const samplePool4: ISamplePool = {
  id: 'samplePool4',
  orderId: 'order126',
  samples: [
    {
      id: 'sample5',
      version: 'dummy',
      primerLiterature: 'Darwin et al, 1872',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_5.ID',
      reverseFileId: 'reverse_read_5.ID',
      forwardPrimer: 'primer5',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      reversePrimer: 'primer6',
      customerSampleName: 'customerSampleD'
    },
    {
      id: 'sample6',
      version: 'dummy',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      // sampleState: "Processed",
      primerLiterature: 'Darwin et al, 1872',
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_6.ID',
      reverseFileId: 'reverse_read_6.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      customerSampleName: 'customerSampleE'
    }
  ],
  negativeControls: []
}

export const samplePool5: ISamplePool = {
  id: 'samplePool5',
  orderId: 'order127',
  samples: [
    {
      id: 'sample7',
      version: 'dummy',
      primerLiterature: 'Darwin et al, 1872',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_7.ID',
      reverseFileId: 'reverse_read_7.ID',
      forwardPrimer: 'primer7',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      reversePrimer: 'primer8',
      customerSampleName: 'customerSampleF'
    }
  ],
  negativeControls: []
}

export const samplePool6: ISamplePool = {
  id: 'samplePool6',
  orderId: 'order128',
  samples: [
    {
      id: 'sample8',
      version: 'dummy',
      primerLiterature: 'Darwin et al, 1872',
      itemType: 'SAMPLE',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'forward_read_8.ID',
      reverseFileId: 'reverse_read_8.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      }
    }
  ],
  negativeControls: [
    {
      id: 'control4',
      version: 'dummy',
      itemType: 'NEGATIVE_CONTROL',
      isTrimmed: false,
      isMerged: false,
      forwardFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      forwardFileId: 'negative_forward_read_4.ID',
      reverseFile: {
        id: 'forward_read_soil001.ID',
        orderId: 'order_67890',
        poolId: 'pool_003',
        fileName: 'soil_forward_001.fastq',
        encodedMd5: 'md5',
        location: 'https://filelocation',
        validUntil: 'validUntilDateString'
      },
      reverseFileId: 'negative_reverse_read_4.ID'
    }
  ]
}
